import * as React from 'react';
import { connect } from 'react-redux';
import { parse } from 'qs';
import { Trans, withTranslation } from 'react-i18next';
import Detect from 'mobile-detect';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import LoginForm from '../../forms/login';

const MailReceivedContainer = ({ location, formValues }) => {
  const query = parse(location.search, { ignoreQueryPrefix: true });
  const device = new Detect(window && window.navigator ? window.navigator.userAgent : '');

  const isPhone = !!device.phone();

  return (
    <div id="MailReceived" className="balloon">
      {isPhone ? (
        <>
          <h2><Trans i18nKey="authentication:mail_received" /></h2>
          <div className="Authentication__Form__Description"><Trans i18nKey="authentication:continue_on_web" values={{ email: query.email }} components={[<b />]} /></div>
        </>
      ) : (
        <LoginForm
          hideUsername
          labels={{
            title: <h2><Trans i18nKey="authentication:mail_received" /></h2>,
            description: (
              <div className="Authentication__Form__Description"><Trans i18nKey="authentication:temporary_password_sent" values={{ email: query.email }} components={[<b />]} /></div>
            ),
            note: (
              <div className="Authentication__Form__Helpdesk">
                <Trans i18nKey="authentication:check_spam" components={[<a href="/auth/forgot" />]} />
              </div>
            ),
          }}
          username={query.email}
          formValues={formValues}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  formValues: (state.form.authenticate && state.form.authenticate.values) || { username: '' },
});

export default withTranslation()(connect(mapStateToProps)(pageWrapper(EEventNames.VISITED_MAIL_RECEIVED_PAGE)(MailReceivedContainer)));
